import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { ButtonReset } from '@helpers/global';
import { Device, from } from '@helpers/media';
import { m } from 'framer-motion';
import styled from 'styled-components';
const Image = styled(m.img) ``;
const Video = styled(m.video) ``;
const ControlButton = styled.button `
  ${ButtonReset};
  display: flex;
  height: 50px;
  place-content: center;
  place-items: center;
  width: 50px;
  background-color: ${brand.green};
  color: ${brand.white};
  position: absolute;
  bottom: 0;
  left: 50%;

  &[data-variant='prev'] {
    transform: translate(calc(-100% - 4px), 50%);
  }

  &[data-variant='next'] {
    transform: translate(4px, 50%);
  }

  svg {
    display: block;
    height: 25px;
    width: 25px;
    ${transition('transform')};
  }

  &:hover svg {
    transform: scale(1.1);
  }

  &:disabled {
    opacity: 0.5;

    svg {
      transform: none;
    }
  }

  @media ${from(Device.TabletLarge)} {
    bottom: 50%;

    &[data-variant='prev'] {
      transform: translate(-50%, 50%);
      left: 0;
    }

    &[data-variant='next'] {
      transform: translate(50%, 50%);
      right: 0;
      left: auto;
    }
  }
`;
const ModalGalleryStyles = {
    Image,
    Video,
    ControlButton,
};
export default ModalGalleryStyles;
